import type CK from '~/types/contentking';

import {
	useAccountDefaultLighthouseThresholdsQuery,
} from './useAccountDefaultLighthouseThresholds.gql';



function useAccountDefaultLighthouseThresholds(accountId: CK.AccountId | null) {
	const { data } = useAccountDefaultLighthouseThresholdsQuery({
		skip: accountId === null,
		variables: {
			accountId: accountId ?? -1,
		},
	});

	return data?.account?.defaultLighthouseThresholds ?? null;
}



export default useAccountDefaultLighthouseThresholds;
